import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Session} from 'src/app/interfaces/session-data';
import gsap from 'gsap';
import {DOCUMENT} from '@angular/common';
import {PaymentService} from '../../services/payment/payment.service';
import {TransactionService} from '../../services/transaction/transaction.service';
import {TransactionStatus} from '../../interfaces/payment-option';
import {GetPostbackFormDataResponse} from '../../interfaces/PostbackFormData/GetPostbackFormDataResponse';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    private paymentService: PaymentService,
    private transactionService: TransactionService) { }

  sessionData: Session;
  redirectFailedURL: string;
  transactionStatus: TransactionStatus;

  ngOnInit(): void {

    gsap.set('svg', { visibility: 'visible' });
    gsap.to('#headStripe', {
      y: 0.5,
      rotation: 1,
      yoyo: true,
      repeat: -1,
      ease: 'sine.inOut',
      duration: 1
    });
    gsap.to('#spaceman', {
      y: 0.5,
      rotation: 1,
      yoyo: true,
      repeat: -1,
      ease: 'sine.inOut',
      duration: 1
    });
    gsap.to('#craterSmall', {
      x: -3,
      yoyo: true,
      repeat: -1,
      duration: 1,
      ease: 'sine.inOut'
    });
    gsap.to('#craterBig', {
      x: 3,
      yoyo: true,
      repeat: -1,
      duration: 1,
      ease: 'sine.inOut'
    });
    gsap.to('#planet', {
      rotation: -2,
      yoyo: true,
      repeat: -1,
      duration: 1,
      ease: 'sine.inOut',
      transformOrigin: '50% 50%'
    });

    gsap.to('#starsBig g', {
      rotation: 'random(-30,30)',
      transformOrigin: '50% 50%',
      yoyo: true,
      repeat: -1,
      ease: 'sine.inOut'
    });
    gsap.fromTo(
      '#starsSmall g',
      { scale: 0, transformOrigin: '50% 50%' },
      { scale: 1, transformOrigin: '50% 50%', yoyo: true, repeat: -1, stagger: 0.1 }
    );
    gsap.to('#circlesSmall circle', {
      y: -4,
      yoyo: true,
      duration: 1,
      ease: 'sine.inOut',
      repeat: -1
    });
    gsap.to('#circlesBig circle', {
      y: -2,
      yoyo: true,
      duration: 1,
      ease: 'sine.inOut',
      repeat: -1
    });

    gsap.set('#glassShine', { x: -68 });

    gsap.to('#glassShine', {
      x: 80,
      duration: 2,
      rotation: -30,
      ease: 'expo.inOut',
      transformOrigin: '50% 50%',
      repeat: -1,
      repeatDelay: 8,
      delay: 2
    });

    this.sessionData = JSON.parse(sessionStorage.getItem('sessionData'));
    // session data is cleared thus getting redirectFailedURL from it fails

    if (this.sessionData)
      // TODO: get from postback
      // sessionStorage.setItem('redirectFailedURL', this.sessionData.redirectFailedURL);

    // this.redirectFailedURL = this.sessionData.redirectFailedURL;
    this.redirectFailedURL = sessionStorage.getItem('redirectFailedURL');
  }

  goBackToMerchant(){
    this.transactionService.getTransactionStatus(sessionStorage.getItem('sessionToken')).subscribe((data: TransactionStatus) => {
      this.transactionStatus = data;
      // tslint:disable-next-line: max-line-length
      this.paymentService.returnToMerchant(sessionStorage.getItem('sessionToken')).subscribe((dataRedir: GetPostbackFormDataResponse) => {
        // sessionStorage.clear();
      });
    });
  }

}
